module.exports = __webpack_public_path__ + "static/media/iReForm-old.17ced5ea.jpg";